<script lang="ts" setup>
  import type { RoundResultsView } from '../../../../shared/api/round.ts';
  import SongCardHorizontal from '../song/SongCardHorizontal.vue';
  import CorrectGuessCount from './CorrectGuessCount.vue';
  import RoundResultsLayout from './RoundResultsLayout.vue';

  defineProps<{ data: RoundResultsView; secondsLeft: string; isHost: boolean }>();
</script>

<template>
  <RoundResultsLayout :data="data" :is-host="isHost" :seconds-left="secondsLeft">
    <SongCardHorizontal
      v-if="data.round.chooserSongSubmissionScore.songSubmission"
      :song="data.round.chooserSongSubmissionScore.songSubmission.song"
      label="You chose"
    />

    <CorrectGuessCount :song-submission-scores="data.round.songSubmissionScores" />
  </RoundResultsLayout>
</template>
